<template>
  <v-container :class="RelationId ? 'pa-0' : undefined" fluid grid-list-lg>
    <v-card :loading="loading" outlined>
      <ListTitle
        :access="false"
        :showBackButton="RelationId ? false : true"
        :title="$t('pageHeader.comment')"
      />

      <v-card-text v-if="RelationId">
        <v-layout
          class="pt-2 pl-2 pr-2"
          align-start="align-start"
          justify-center="justify-center"
          row
        >
          <v-avatar size="40px">
            <img
              v-if="currentUser.imageUrl"
              :src="currentUser.imageUrl"
              alt="User"
            />
            <img v-else src="@/assets/images/user.jpeg" alt="User" />
          </v-avatar>
          <v-layout class="ml-2 mr-2" column>
            <v-flex>
              <v-text-field
                class="mt-0 pt-0"
                v-model="comment"
                label="Comment"
                placeholder="Start typing what in in my your mind about this customer"
                outlined
                dense
                @keydown.enter="saveComment()"
                hide-details
              >
              </v-text-field>
            </v-flex>
            <v-flex class="pt-0 text-right" v-if="comment">
              <v-btn text="text" @click="cancel">cancel</v-btn>
              <v-btn color="info" @click="saveComment">comment</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-divider class="mt-3" v-if="RelationId"></v-divider>
      <v-card-text class="pt-1">
        <v-container fluid class="pa-0">
          <v-data-table
            :headers="headers"
            :items="comments"
            :search="search"
            :loading="loading"
            :server-items-length="count"
            :footer-props="{ 'items-per-page-options': [10, 25, 35, 50]}"
            :options.sync="options"
          >
            <template v-slot:top>
              <v-row class="my-5">
                <v-col cols="12" md="5" sm="12">
                  <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
                    hide-details clearable>
                  </v-text-field>
                </v-col>
                <v-spacer> </v-spacer>
                <v-col cols="12" md="3" sm="12" v-if="!RelationId">
                  <DateTimePicker defaultRange="today" :range="true" :hideTime="true" v-model="dateTime"
                    @submit="getList()" />
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-left">
                  {{ item.createdAt | moment("MM/DD/YYYY hh:mm A") }}
                </td>
                <td class="text-left" >
                  <div v-if="item.User">{{ item.User.name }}</div>
                  <div v-else>Public Entry</div>
                </td>
                <td class="text-left pointer" v-if="!RelationId" @click="viewProfile(item)">
                  <span v-if="item.TypeId === 1"><v-icon color="green">mdi-account-outline</v-icon> {{ item.Customer.name
                    }}</span>
                  <span v-if="item.TypeId === 5"><v-icon color="red">mdi-hand-coin-outline</v-icon> {{ item.Donor.name
                    }}</span>
                </td>
                <td class="text-left">{{ item.message }}</td>
              </tr>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import commentService from "../service.js";
import { mapGetters } from "vuex";
const DateTimePicker = () => import("@/components/DateTimePicker");

export default {
  props: ["RelationId", "TypeId"],
  data() {
    return {
      comment: null,
      comments: [],
      loading: true,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      headers: [],
      search: null
    };
  },
  created(){
    this.headers.push({
      text: "Date",
      align: "left",
      value: "createdAt",
      width: '20%',
      sortable: true
    },
    {
      text: "User",
      align: "left",
      value: "User.name",
      width: '20%',
      sortable: false
    })
    if(!this.RelationId){
      this.headers.push({
        text: "Name",
        align: "left",
        value: "name",
        width: '20%',
        sortable: false
      })
    }
    this.headers.push({
      text: "Message",
      align: "left",
      value: "message",
      sortable: true
    })
    this.getList()
  },
  watch: {
    RelationId: {
      immediate: true,
      handler() {
        this.getList();
      }
    },
    search: {
      handler() {
        this.getList();
      }
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  components: {
    DateTimePicker
  },
  methods: {
    cancel() {
      this.comment = null;
    },
    save(data) {
      return commentService.create(data).then(() => {
        this.comment = null;
        this.getList();
      });
    },
    saveComment() {
      const obj = {
        RelationId: this.RelationId.id,
        message: this.comment,
        TypeId: this.TypeId
      }

      console.log('obj', obj)
      this.save(obj);
    },
    viewProfile(val) {
      if(val.TypeId === 1){
        this.$router.push({ path: `/parents/${val.Customer.id}/profile` });
      } else if(val.TypeId === 5){
        this.$router.push({ path: `/donors/${val.Donor.id}/profile` });
      }
    },
    getList() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let offset = 0
      if (itemsPerPage > 0 && page) {
        offset = itemsPerPage * page - itemsPerPage;
      }
      let where = {
        limit: itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0]
      }
      if(this.RelationId){
        where.RelationId = this.RelationId.id
      }
      if(this.TypeId){
        where.TypeId = this.TypeId
      }else{
        where.filteredTypes = [1,5]
      }
      if(!this.RelationId){
        where.start = this.dateTime.start
        where.end = this.dateTime.end
      }
      if (this.search && this.search.length >= 3) {
        where.search = this.search
      } else {
        where.offset = offset
      }
      return commentService
        .getAll(where)
        .then(response => {
          this.comments = response.data;
          this.count = response.count
          // console.log("comets ", this.comments);
          this.loading = false;
          return response;
        });
    }
  }
};
</script>

<style scoped></style>
